<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between align--center mb-3">
          <h1 class="ma-0">Акции доставки</h1>
          <va-button color="info" @click="openCreateModal">
            Добавить акцию
          </va-button>
        </div>
        <va-data-table
          :fields="fields"
          :data="list"
          class="va-table va-table--hoverable"
        >
          <template slot="title" slot-scope="props">
            {{ props.rowData.title }}
          </template>
          <template slot="period" slot-scope="props">
            {{ props.rowData.date_from }} – {{ props.rowData.date_to }}
          </template>
          <template slot="delivery_type" slot-scope="props">
            {{ getTypeTitle(props.rowData.delivery_type_id) }}
          </template>
          <template slot="min_cart_sum" slot-scope="props">
            {{
              props.rowData.min_cart_sum != null
                ? props.rowData.min_cart_sum
                : "—"
            }}
          </template>
          <template slot="free_or_price" slot-scope="props">
            <span v-if="props.rowData.make_free">Бесплатно</span>
            <span v-else-if="props.rowData.price_override != null">{{
              props.rowData.price_override
            }}</span>
            <span v-else>—</span>
          </template>
          <template slot="priority" slot-scope="props">
            {{ props.rowData.priority }}
          </template>
          <template slot="is_active" slot-scope="props">
            <va-badge
              :text="props.rowData.is_active ? 'Да' : 'Нет'"
              :color="props.rowData.is_active ? 'success' : 'gray'"
            />
          </template>
          <template slot="actions" slot-scope="props">
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-pencil"
              @click="edit(props.rowData)"
            />
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-trash"
              @click="remove(props.rowData.id)"
            />
          </template>
        </va-data-table>
      </va-card>
    </va-inner-loading>

    <va-modal v-model="showModal" hide-default-actions size="large">
      <template #header>
        <span>{{ editId ? "Редактировать акцию" : "Новая акция" }}</span>
      </template>
      <DeliveryPromotionForm
        :initial="editItem"
        :delivery-types="typeOptions"
        @submit="onSubmit"
        @cancel="closeModal"
      />
    </va-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import DeliveryPromotionForm from "../../components/delivery-management/DeliveryPromotionForm.vue";

export default {
  name: "DeliveryPromotions",
  components: { DeliveryPromotionForm },
  data() {
    return {
      showModal: false,
      editId: null,
      editItem: null,
    };
  },
  computed: {
    ...mapState("deliveryPromotions", ["list"]),
    ...mapGetters({ loader: "isLoading" }),
    typesList() {
      return this.$store.state.deliveryTypes.list || [];
    },
    typeOptions() {
      const list = this.typesList;
      return [
        { value: null, text: "Все типы" },
        ...list.map((t) => ({ value: t.id, text: t.title })),
      ];
    },
    fields() {
      return [
        { name: "__slot:title", title: "Название" },
        { name: "__slot:period", title: "Период" },
        { name: "__slot:delivery_type", title: "Тип доставки" },
        { name: "__slot:min_cart_sum", title: "Мин. сумма" },
        { name: "__slot:free_or_price", title: "Бесплатно / цена" },
        { name: "__slot:priority", title: "Приоритет" },
        { name: "__slot:is_active", title: "Активна" },
        { name: "__slot:actions", title: "", width: "100px" },
      ];
    },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch("deliveryTypes/fetchList"),
      this.fetchList(),
    ]);
  },
  methods: {
    ...mapActions("deliveryPromotions", [
      "fetchList",
      "create",
      "update",
      "delete",
    ]),
    getTypeTitle(id) {
      if (id == null) return "—";
      const t = this.typesList.find((x) => Number(x.id) === Number(id));
      return t ? t.title : "—";
    },
    openCreateModal() {
      this.editId = null;
      this.editItem = null;
      this.showModal = true;
    },
    edit(row) {
      this.editId = row.id;
      this.editItem = { ...row };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editId = null;
      this.editItem = null;
    },
    async onSubmit(form) {
      try {
        if (this.editId) {
          await this.update({ id: this.editId, ...form });
          this.$notify?.({ type: "success", title: "Сохранено" });
        } else {
          await this.create(form);
          this.$notify?.({ type: "success", title: "Создано" });
        }
        this.closeModal();
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
    async remove(id) {
      if (!confirm("Удалить акцию?")) return;
      try {
        await this.delete(id);
        this.$notify?.({ type: "success", title: "Удалено" });
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
  },
};
</script>
